"use client";

import type { PropsWithChildren } from "react";

import { GoogleTagManager } from "@/services/analytics/gtm";
import { QueryClientProvider } from "@/services/http";
import { HubSpot } from "@/services/hub-spot/hub-spot-script";

export function Analytics() {
  return (
    <>
      <HubSpot />
      <GoogleTagManager />
    </>
  );
}

export function ClientLayout({ children }: PropsWithChildren) {
  return (
    <>
      <Analytics />
      <QueryClientProvider>{children}</QueryClientProvider>
    </>
  );
}
